export default "__VITE_ASSET__DVM4p1Qn__"